/**
 * trackDataService — My Track Data retrieval
 *
 * Architecture:
 * - Track data files are organized by contact/user.
 * - Each file is available for download in Excel and JSON formats.
 * - Search by serial number with optional advanced search filters.
 * - Route: /my-track-data
 */
import { apiGet, apiPost } from './apiClient';

/**
 * Search track data files
 * @param {Object} params - { serialNumber, advancedFilters }
 * @returns {Promise<Object>} { contacts: [{ name, files: [...] }] }
 */
export async function searchTrackData(params = {}) {
  // TODO: Replace with real API call
  // return apiClient.get('/api/track-data', { params });

  // Stub data matching the live non-prod UI
  return {
    contacts: [
      {
        id: 'contact-1',
        name: 'Bruce',
        files: [
          {
            id: 'td-001',
            name: 'Track data file March 2026',
            date: '2026-05-03',
            excelUrl: '/api/track-data/td-001/excel',
            jsonUrl: '/api/track-data/td-001/json',
          },
          {
            id: 'td-002',
            name: 'Track data file February 2026',
            date: '2026-01-02',
            excelUrl: '/api/track-data/td-002/excel',
            jsonUrl: '/api/track-data/td-002/json',
          },
          {
            id: 'td-003',
            name: 'Track data file January 2026',
            date: '2026-01-01',
            excelUrl: '/api/track-data/td-003/excel',
            jsonUrl: '/api/track-data/td-003/json',
          },
        ],
      },
      {
        id: 'contact-2',
        name: 'King',
        files: [
          {
            id: 'td-004',
            name: 'Track data file April 2026',
            date: '2026-04-15',
            excelUrl: '/api/track-data/td-004/excel',
            jsonUrl: '/api/track-data/td-004/json',
          },
        ],
      },
    ],
  };
}

/**
 * Get download URL for a track data file
 * @param {string} fileId
 * @param {'excel'|'json'} format
 * @returns {Promise<string>} Download URL
 */
export async function getTrackDataDownloadUrl(fileId, format) {
  // TODO: Replace with real API call returning signed URL
  console.log('[trackDataService] Download requested (stub):', fileId, format);
  return `/api/track-data/${fileId}/${format}`;
}
